<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    appMargin="0"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="detailForm">
      <div class="field" [ngClass]="displayFieldCss('totalUnallocatedShare')">
        <label> Shares Unallocated ({{ shareUnallocatedPercentage }}%)</label>
        <app-currencyfmt-number-input
          [placeholder]="'Shares Unallocated'"
          formControlName="totalUnallocatedShare"
        ></app-currencyfmt-number-input>
        <app-field-error-display
          [displayError]="isFieldValid('totalUnallocatedShare')"
          errorMsg="Please enter Shares Unallocated"
        >
        </app-field-error-display>
      </div>

      <div
        class="field required"
        [ngClass]="displayFieldCss('totalShareCapital')"
      >
        <label> Total Share Capital</label>
        <app-currencyfmt-number-input
          [placeholder]="'Total Share Capital'"
          formControlName="totalShareCapital"
        ></app-currencyfmt-number-input>
        <app-field-error-display
          [displayError]="isFieldValid('totalShareCapital')"
          errorMsg="Please enter Total Share Capital"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Close
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!detailForm.valid || pending"
    (click)="submit()"
    autofocus
  >
    Save
  </button>
</div>
